import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  IHealthPlanMaster,
  IHealthPlanMasterList,
} from '../Infrastructure/Interfaces';

const healthPlanMasterInitialState: IHealthPlanMasterList = {
  loading: true,
  healthPlanMasterList: [],
};

const ItemInitialState: IHealthPlanMaster = {
  healthPlanMasterId: 0,
  healthPlanName: '',
  healthPlanId: '',
  sendOption1: '',
  sendOption2: '',
  sendOption3: '',
  sendOption4: '',
  isActive: true,
  createdBy: '',
  createdOn: '',
  modifiedBy: '',
  modifiedOn: '',
};

const HealthPlanMasterItemSlice = createSlice({
  name: 'HealthPlanMasterItem',
  initialState: { value: ItemInitialState },
  reducers: {
    setHealthPlanMasterItem: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const fetchHealthPlanMasterList = createAsyncThunk(
  'fetchHealthPlanMasterList',
  async () => {
    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    //const token = globalFetchToken(tokenurl, "", "5053");
    return axios.get(tokenurl).then(res => {
      if (res.data.success) {
        return axios
          .get(baseurl + '/Payer/get_healthplannames', {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + res.data.token,
            },
          })
          .then(response => {
            if (response.data.success) {
              return response.data.result;
            }
          });
      }
    });
  }
);

const HealthPlanMasterListSlice = createSlice({
  name: 'healthplanmasterlist',
  initialState: healthPlanMasterInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchHealthPlanMasterList.fulfilled, (state, action) => {
      state.loading = false;
      state.healthPlanMasterList = action.payload;
    });
    builder.addCase(fetchHealthPlanMasterList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchHealthPlanMasterList.rejected, (state, action) => {
      state.loading = false;
      state.healthPlanMasterList = [];
    });
  },
});

export const HealthPlanMasterReducer = HealthPlanMasterListSlice.reducer;

export const { setHealthPlanMasterItem } = HealthPlanMasterItemSlice.actions;

export const HealthPlanMasterItemReducer = HealthPlanMasterItemSlice.reducer;
